/**
 * Mirror of the backend transform in campaign_executor._newlines_to_br, so
 * every signature preview (Settings > Mailboxes, Settings > Signatures, the
 * launch wizard's signature step, the campaign review modal) lines up exactly
 * with what arrives in the inbox.
 */
export function newlinesToBr(html: string | null | undefined): string {
  if (!html) return ''
  const normalized = html.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  return normalized.replace(/(?<!>)\n/g, '<br>\n')
}

/** True when a signature has visible content (whitespace only counts as empty). */
export function hasSignatureContent(html: string | null | undefined): boolean {
  return !!(html && html.trim())
}
